import * as React from 'react';
import { format as formatWithFns, getYear } from 'date-fns';
import { Badge } from '@traceair/tds';
import { Site } from '../../../../../types';

type SiteUpdatedTooltipProps = {
  className?: string;
  site: Site;
};

const currentYear = getYear(new Date());

const formatDate = (date: Date) => {
  const year = getYear(date);

  let format = 'MMM d';

  if (year !== currentYear) {
    format += ', yyyy';
  }

  return formatWithFns(date, format);
};

export const SiteUpdatedTooltip: React.FC<SiteUpdatedTooltipProps> = ({ className, site }) => {
  const date = site.boundary?.properties?.updated;

  if (!date) {
    return null;
  }

  const updatedDate = new Date(date);

  return (
    <div className={className} title="Indicates the last update of the Flight Area">
      <Badge size="s" type="neutral-black" label={`Updated ${formatDate(updatedDate)}`} />
    </div>
  );
};
